import { render, staticRenderFns } from "./successTips.vue?vue&type=template&id=4671971a&scoped=true&"
import script from "./successTips.vue?vue&type=script&lang=js&"
export * from "./successTips.vue?vue&type=script&lang=js&"
import style0 from "./successTips.vue?vue&type=style&index=0&id=4671971a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4671971a",
  null
  
)

export default component.exports